import { useState } from 'react';

const faqItems = [
    {
        question: "Как работать с онлайн дневником? ",
        answer: (
            <>
                <p>Lorem ipsum dolor sit amet consectetur. Odio sagittis eget est morbi orci eget. Et nec eu non sit tortor aliquet ut. Diam neque duis nisi varius duis. Sed interdum eget fermentum varius hendrerit. Arcu commodo amet sed duis ullamcorper ultricies sed netus. Nam tempus ullamcorper amet sed nunc dictum. Pulvinar nunc condimentum eget enim tincidunt elementum nisl felis. Ac sagittis ullamcorper eget cursus arcu. </p>
            </>
        )
    },
    {
        question: "Что такое онлайн-чекап?",
        answer: (
            <p><a href="https://lab4u.ru/about">Lab4U</a>Lorem ipsum dolor sit amet consectetur.</p>
        )
    },
    {
        question: "Как подбирается программа тренировок и питания?",
        answer: (
            <p>Сервис предоставляет привилегии в виде скидок...</p>
        )
    },
    {
        question: "Как оформить подписку на использование сеервиса?",
        answer: (
            <p>Напишите нам в поддержку или заполните форму обратной связи...</p>
        )
    },
    {
        question: "Что такое онлайн-чекап?",
        answer: (
            <>
                <p><a href="https://jamanetwork.com/journals/jamainternalmedicine/article-abstract/2804309">
                    Исследованиями доказано, что нейросеть даёт на 79% более точные диагнозы...</a></p>
                <p>Алгоритм сервиса обучается под вас, анализирует результаты...</p>
            </>
        )
    },
    {
        question: "Как подбирается программа тренировок и питания?",
        answer: (
            <p>Да, первые 30 дней бесплатно после прохождения теста.</p>
        )
    },
    {
        question: "Как оформить подписку на использование сеервиса?",
        answer: (
            <p>Да, первые 30 дней бесплатно после прохождения теста.</p>
        )
    },
];

export const FAQPage = () => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const toggleAccordion = (index: number) => {
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    return (
        <main className="layout__content">
            <section className="section layout__section faq">
                <div className="container">
                    <header className="section__header">
                        <h1 className="title section__title">Вопросы и ответы</h1>
                    </header>
                    <div className="section__content">
                        <div className="faq__block">
                            {faqItems.map((item, index) => (
                                <div
                                    className={`accordion ${activeIndex === index ? '_active' : ''}`}
                                    key={index}
                                >
                                    <header
                                        className="accordion__header"
                                        onClick={() => toggleAccordion(index)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <h6 className="accordion__title">{item.question}</h6>
                                        <div className="accordion__toggle" />
                                    </header>
                                    {activeIndex === index && (
                                        <div className="accordion__content">
                                            <div className="text accordion__text">{item.answer}</div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};
